import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <>
      <nav className="relative container mx-auto px-4 sm:px-6 py-3 flex justify-between items-center">
        <div className="text-xl text-[#1C4A35] sm:text-2xl font-bold">EYES Ghana</div>

        <div className="hidden md:flex items-center gap-6 font-bold">
          <a href="#about" className="hover:text-green-600 text-green-700">About Us</a>
          <a href="#benefits" className="hover:text-green-600 text-green-700">Benefits</a>
          <Link to="/chat" className="hover:text-green-600 text-green-700">AgriChat</Link>
          <Link
            to="/consent"
            className="px-6 py-2 rounded-md transition-all text-white hover:opacity-90"
            style={{ background: 'linear-gradient(135deg, #F89D08 0%, #925C05 100%)' }}
          >
            Start Registration
          </Link>
        </div>

        <button
          onClick={toggleMenu}
          className="md:hidden p-2 hover:bg-green-50 rounded-lg transition-colors"
          aria-label="Toggle menu"
          aria-expanded={isMenuOpen}
          aria-controls="mobile-menu"
        >
          {isMenuOpen ? (
            <X className="w-6 h-6 text-green-500" />
          ) : (
            <Menu className="w-6 h-6 text-green-500" />
          )}
        </button>
      </nav>

      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            id="mobile-menu"
            role="menu"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.22 }}
            className="md:hidden bg-white border-t border-gray-200 overflow-hidden absolute left-0 right-0 top-full z-50 shadow-sm"
          >
            <div className="px-4 py-3 flex flex-col gap-2">
              <a
                href="#about"
                onClick={closeMenu}
                role="menuitem"
                className="text-green-700 hover:text-orange-400 transition-colors py-2 text-base"
              >
                About Us
              </a>
              <a
                href="#benefits"
                onClick={closeMenu}
                role="menuitem"
                className="text-green-700 hover:text-orange-400 transition-colors py-2 text-base"
              >
                Benefits
              </a>
              <Link
                to="/chat"
                onClick={closeMenu}
                role="menuitem"
                className="text-green-700 hover:text-orange-400 transition-colors py-2 text-base"
              >
                AgriChat
              </Link>
              <Link
                to="/consent"
                onClick={closeMenu}
                role="menuitem"
                className="text-white px-4 py-2 rounded-md transition-all text-center mt-1 hover:opacity-90"
                style={{ background: 'linear-gradient(135deg, #F89D08 0%, #925C05 100%)' }}
              >
                Start Registration
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Navbar;
